import { ITooltipInheritedProps } from 'kui';

export enum EUnreadCounterSize {
    BASE = 'BASE',
    SMALL = 'SMALL',
}

export interface IUnreadCounterFields {
    count: number;
    size?: EUnreadCounterSize;
    tooltip?: ITooltipInheritedProps;
}

export interface IUnreadCounterEvents {
    onClick?: (e: React.MouseEvent) => void;
}

export interface IUnreadCounterProps extends
    IUnreadCounterFields,
    IUnreadCounterEvents
{}
